import React from 'react';
import { Button } from '../components/Button';

const base = process.env.PUBLIC_URL || '';

export function ServicesSection() {
  return (
    <section id="diensten" className="section-diensten" aria-label="Diensten">
      <div className="diensten-layout">
        <div className="diensten-tiles-wrapper">
          <div className="diensten-tiles">
            <div className="diensten-tile">
              <img src={`${base}/images/home/globe.png`} alt="" className="diensten-tile-icon" />
              <div className="diensten-tile-content">
                <h3>Web design</h3>
                <p>
                  Website ontwerp en ontwikkeling voor jouw bedrijf of persoonlijk project
                </p>
              </div>
            </div>
            <div className="diensten-tile">
              <img src={`${base}/images/home/stars.png`} alt="" className="diensten-tile-icon" />
              <div className="diensten-tile-content">
                <h3>UI Design</h3>
                <p>
                  Ontwerpen van websites die aansluiten bij jouw wensen
                </p>
              </div>
            </div>
            <div className="diensten-tile">
              <img src={`${base}/images/home/cursor-hand.png`} alt="" className="diensten-tile-icon" />
              <div className="diensten-tile-content">
                <h3>UX Design</h3>
                <p>
                  Gebruiksvriendelijke websites die het navigeren makkelijk maakt voor gebruikers
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="diensten-right">
          <h2>Mijn diensten</h2>
          <p>
            Past een van de diensten van Dabra bij een project van jou of jouw bedrijf? Stuur dan een mail!
          </p>
          <Button href="#contact" variant="secondary">
            Contact
          </Button>
        </div>
      </div>
    </section>
  );
}

